module.exports = __webpack_public_path__ + "img/no-data.945118b2.png";